import window from '../window/index.js';
import { once } from '@immutabl3/utils';
import { NAME } from '../constants.js';
import store from './sessionStorage.js';
import orchestrator from '../orchestrator/index.js';

let lastSavedY;

const key = `${NAME}_SCROLL_POSITION`;
const RESTORE_Y = +store.getItem(key);

// maintain scroll position
export const restore = once(() => {
  const top = RESTORE_Y ?? 0;
  orchestrator.jumpTo({ top });
  return top;
});
  
// save current scroll
export const save = () => {
  const y = window.scrollTop();
  if (y === lastSavedY) return;
    
  lastSavedY = y;
  store.setItem(key, y);
};